import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { getInsuranceTypesList } from "../../../../../../../services/tasyInsuranceType.service";

const translationPath = "page.4uBus.integrationRule.integrationRuleMov.";

export const PlanOperationType = memo(() => {
  const { t } = useTranslation();

  const { sendRequest } = useFetch(getInsuranceTypesList);

  const [planOperationTypes, setPlanOperationTypes] = useState<ISelectType[]>([]);

  const params = useMemo(() => {
    return {
      Identifier: 3371,
    };
  }, []);

  const fetchPlanOperationType = useCallback(async () => {
    const { data, success } = await sendRequest(params);
    if (data && success) {
      const newData = data.map((item) => ({
        id: item.identifierValue,
        name: item.domainValueName,
      }));

      setPlanOperationTypes(newData);
    }
  }, [sendRequest, params]);

  useEffect(() => {
    fetchPlanOperationType();
  }, [fetchPlanOperationType]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoCompleteMulti
        options={planOperationTypes}
        name="uBusIntegrationRuleMovPlanOperationTypes"
        size="small"
        getOptionLabel={({ name }) => name}
        label={t(translationPath + "plan_operation_type")}
        keepOpenOnSelect
      />
    </Grid>
  );
});
